import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

// Page de sélection du type d'inscription
const RegistrationType = () => {
  const navigate = useNavigate();

  const options = [
    {
      id: 'artist',
      title: 'Artiste',
      icon: 'Mic',
      description: 'Créez votre profil, mettez en avant votre univers et connectez-vous avec des lieux et des agents.'
    },
    {
      id: 'venue',
      title: 'Lieu',
      icon: 'MapPin',
      description: 'Clubs, festivals, restaurants ou espaces événementiels : diffusez vos programmations et trouvez des talents.'
    },
    {
      id: 'agent',
      title: 'Agent',
      icon: 'Briefcase',
      description: 'Gérez votre roster d’artistes, centralisez vos échanges et facilitez le suivi des commissions.'
    },
    {
      id: 'media',
      title: 'Média / Presse',
      icon: 'Newspaper',
      description: 'Accédez aux press kits, suivez les artistes émergents et identifiez les tendances du secteur.'
    }
  ];

  const handleSelect = (type) => {
    // Pour l'instant on réutilise le formulaire existant partenaire.
    // On pourrait stocker le type dans le state ou query param.
  localStorage.setItem('pendingRegistrationType', type);
  navigate('/partner-registration');
  };

  return (
    <div className="min-h-screen bg-background pt-24 pb-16 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Choisissez votre espace</h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Sélectionnez le profil qui correspond à votre activité. Vous pourrez ensuite compléter un formulaire adapté.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {options.map(opt => (
            <div key={opt.id} className="bg-card border border-border rounded-xl p-6 flex flex-col shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 rounded-lg bg-accent flex items-center justify-center mb-4">
                <Icon name={opt.icon} size={28} color="white" />
              </div>
              <h2 className="text-xl font-semibold mb-2">{opt.title}</h2>
              <p className="text-sm text-muted-foreground mb-6 flex-grow">{opt.description}</p>
              <Button variant="accent" onClick={() => handleSelect(opt.id)}>
                Continuer
              </Button>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <p className="text-sm text-muted-foreground">
            Déjà un compte ?{' '}
            <button onClick={() => navigate('/login')} className="text-accent hover:underline">Se connecter</button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationType;